<template>
  <div class="advancedSearch_main">
    <div id="top" ref="top"></div>
    <el-row class="search-content fx">
      <div class="left-shadow fx-none">
        <AdvanceSearchTab ref="advanceSearchTab" @updateSearchFilter="updateTemplate" />
      </div>
      <div class="fx-full">
        <SearchFilter :key="filterKey" />
      </div>
    </el-row>

    <div class="btns btnsMd">
      <el-button w100 type="dialog-confirm" size="default" @click="searchAndPageOne">搜索</el-button>
      <el-button w100 type="dialog-canel" size="default" @click="clearTemplate">清空</el-button>
      <el-button w100 type="dialog-canel" size="default" @click="saveTemplate">保存为模板</el-button>
    </div>
    <company-card-list @isUnlock-Change="isUnlockChange" :resetUnlockS="isUnlock" :companyType="4" class="cardlist" ref="cardlist" :batchActions="batchActions" :list="list"
      @handle-page-num="handlePageNum" @handle-page="handlePage" v-loading='loading' element-loading-text="耐心等待小T为您大数据计算中…" element-loading-spinner="el-icon-loading">
      <div class="searchBar">
        <!-- <span class="ml-10 font-12">小T为您找到 <span style="color: #ff0000;">{{_totalElements}}</span> 企业商机资源</span> -->
        <span class="font-15-md">小T为您找到 <span class="blueColor" style="color: #5088FF;">{{_totalElements}}</span> 企业商机资源</span>
      </div>
      <template v-slot:beforeBatch>
        <el-button class="gbBatchBtn" :loading="actionLoading" type="info" plain size="small" v-interestExpire @click="batchUnlockFnbefore">解锁前500</el-button>
      </template>
      <!-- <template v-slot:unlockBtn>
            <el-checkbox v-model="isUnlock" label="过滤已解锁" @change="isUnlockChange" class="filter-unlock"></el-checkbox>
      </template> -->
      <template v-slot:two>
        <intel-sort @sortChange="sortChange" :value="sortValue"></intel-sort>
      </template>
    </company-card-list>
    <robot />
    <!-- 右侧悬浮箭头 -->
    <right-float ref="rightFloat" :globalRfType="false" @scrollToView="scrollToView"></right-float>
    <div id="bottom" ref="bottom"></div>
    <unlock-dialog-batch :show.sync="unlockDialogShowBatch" :maxTotal="list.total" :list="companyList" title="批量解锁" :confirmPromise="contactsNumBatchConfirmBatch"></unlock-Dialog-Batch>
    <!-- 批量解锁提示 -->
    <batch-unlock-tip ref="batchUnlockTip"></batch-unlock-tip>
  </div>
</template>
<script>
import companyCardList from '@/views/clue/components/companyCardList'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import Robot from '../components/robot'
import AdvanceSearchTab from '../advancecomponets/AdvancedSearchTab'
import SearchFilter from '../advancecomponets/SearchFilter'
import { saveOrUpdateTemplate, advancedSearch, companyBuried, advancedSearchUnlock, testPoint } from '../api/newClueApi'
import unlockDialogBatch from '../components/unlockDialogBatch'
import batchUnlockTip from '@/components/batchUnlockTip'
import RightFloat from '@/components/rightFloatBtn'
import intelSort from '@/views/wigects/intelSort'
import { X_BLOCK, X_PRODUCT, X_HIDE } from '@/utils/iframeUtils'
export default {
  components: {
    AdvanceSearchTab,
    SearchFilter,
    companyCardList,
    Robot,
    unlockDialogBatch,
    batchUnlockTip,
    RightFloat,
    intelSort
  },
  name: 'advancedSearch',
  provide() {
    return {
      $_search: this, // 搜索事件监听器
      unlockSourceType: 4
    }
  },
  data() {
    return {
      checked: false,
      filterKey: 0,
      list: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        tab: 1,
        tableData: []
      },
      allTotal: 0,
      loading: false,
      inputErrorMessage: '',
      isUnlock: false,
      unlockDialogShowBatch: false,
      companyList: [],
      actionLoading: false,
      scrollTop: 0,
      searchConditionObj: null,//搜索条件
      windowProductObj: { 'scrmqw': 'SCRM企微', 'scrmzy': 'SCRM专业' },
      searchFlag: false,
      sortType: { sortType: null, sortField: null },
      sortValue: null,
    }
  },
  computed: {
    ...mapState({
      surplus: state => state.user.surplus,
      staffInfo: state => state.user.staffInfo
    }),
    batchActions() {
      return this.surplus < 1 ? [false, true, false] : [true, true, false]
    },
    _totalElements() {
      if (this.allTotal < 100) return this.allTotal
      if (this.allTotal < 200000) return `${this.allTotal.toString().split('').reduce((res, v) => res ? res + 0 : v, '')}+`
      return '200000+'
    },
  },
  beforeDestroy() {
    this.$store.commit('resetCondition')
  },
  mounted() {
    // this.advancedSearch({ relationType: 2, conditionVos: [] })
  },
  methods: {
    scrollToView(val) {
      document.getElementById(val).scrollIntoView({
        block: 'start',
        inline: 'nearest',
        behavior: 'smooth'
      })
    },
    // 过滤解锁
    isUnlockChange(val) {
      this.isUnlock = val
      this.goTop()
      this.search()
    },
    goTop() {
      document.querySelector('.pageWrap>.content-scrollbar>.el-scrollbar__wrap').scrollTo(0, 0)
    },
    handlePage(val) {
      this.list.pageNum = val
      this.goTop()
      this.search()
    },
    handlePageNum(val) {
      this.list.pageNum = 1
      this.list.pageSize = val
      this.goTop()
      this.search()
    },
    sortChange(v) {
      this.sortType = v
      this.sortValue = v.sortType ? `${v.sortField}-${v.sortType}` : null
      this.searchAndPageOne()
    },
    saveTemplate() {
      const ref = this.$refs.advanceSearchTab
      const inputValidator = (value) => {
        if (value && value.trim() && value.trim().length <= 10) {
          if (!ref) { return false }
          const index = ref.templateList2.findIndex(e => e.templateName === value)
          if (index !== -1) {
            return '不能重复命名'
          }
          return true
        } else {
          return false
        }
      }
      this.$prompt('请输入模版名称（名称长度为1-10个字符）：', '保存为模板', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        inputValidator,
        inputPlaceholder: '请输入模版名称',
        inputErrorMessage: '长度需为1-10个字符',
        customClass: 'winClass',
      }).then(({ value }) => {
        this.saveOrUpdateTemplate(value)
      }).catch(() => { })

      // this.$refs.advanceSearchTab.templateList2
    },
    clearTemplate() {
      this.$confirm('此操作将永久删除该条件，是否继续？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning',
        customClass: 'winClass delClass',
      }).then(() => {
        this.$store.commit('resetCondition')
        this.updateTemplate()
        this.$message.success('清空成功')
        localStorage.removeItem('inputDefaultCondition')
      }).catch(() => { })
    },
    searchAndPageOne() {
      this.isUnlock = false
      this.list.pageNum = 1
      this.searchFlag = true
      this.search()
    },
    search() {
      const source = this.$store.getters.getDefaultCondition

      // 消息通知 所有子組件監聽的
      this.$emit('search')
      console.log(source, 888)

      localStorage.setItem('inputDefaultCondition', JSON.stringify(source))

      const params = {
        relationType: source.relationType,
        conditionVos: []
      }
      let hasEmpty = false
      const self = this
      function fn(source, arr) {
        source.conditionVos.forEach(e => {
          if (e.childOption) {
            const secondObj = {
              childOption: {
                relationType: e.childOption.relationType,
                conditionVos: []
              }
            }
            params.conditionVos.push(secondObj)
            fn(e.childOption, secondObj.childOption.conditionVos)
          } else {
            // values,
            let { conditionId, conditionType, conditionValues, screenType } = e
            // 检索
            if (!conditionValues.length) {
              e.err = true
              self.$store.commit('hasErr')
              hasEmpty = true
            }
            let values = conditionValues.map(e => e.value || e) // 单选不是对象格式
            // 百度values处理（百度、百度PC、百度移动）
            if (values) {
              values.forEach((v, index) => {
                if (v.toString().includes(',')) {
                  v.split(',').forEach(vv => {
                    values.push(vv)
                  })
                  values.splice(index, 1)
                }
              })
              // //数组去重
              // let arrV = []
              // for(let i =0;i<values.length;i++){
              //     if(arrV.indexOf(values[i])===-1){
              //       arrV.push(values[i])
              //     }
              // }
              // values = arrV
            }
            arr.push({ conditionId, conditionType, values, screenType })
          }
        })
      }
      fn(source, params.conditionVos)

      // console.log(this.$store.getters.getDefaultCondition)
      console.log('params', params)
      if (hasEmpty) {
        this.toErrScoll()
        return
      }
      this.searchConditionObj = params

      this.advancedSearch(params)
    },
    toErrScoll() {
      this.$nextTick(() => {
        try {
          const dom = document.querySelector('.findErr').parentNode
          const posY = dom.getBoundingClientRect().top - dom.parentNode.getBoundingClientRect().top
          document.querySelector('.custom-child').scrollTop = posY
        } catch (error) {
          console.log(error)

        }

      })
    },
    async advancedSearch(params) {
      this.loading = true
      try {
        let isUnlockN = this.isUnlock ? 1 : 0
        const { data, code } = await advancedSearch({
          pageNum: this.list.pageNum,
          pageSize: this.list.pageSize,
          isUnLock: parseInt(isUnlockN),
          data: { ...params },
          ...(this.sortType || {}),
        })
        this.loading = false
        if (code === 200) {
          companyBuried({
            pageNum: this.list.pageNum,
            pageSize: this.list.pageSize,
            data: { ...params },
            searchNum: data.total
          })
          this.list.tableData = data.items
          this.allTotal = data.total
          this.list.total = data.total > 15000 ? 15000 : data.total
          // 埋点
          // console.log('iframe产品线参数',window[X_BLOCK],window[X_HIDE],window[X_PRODUCT])
          let productName = ''
          if (window[X_PRODUCT]) {
            productName = windowProductObj[window[X_PRODUCT]]
          } else {
            if (window[X_BLOCK]) {
              productName = 'SCRM企微'
            } else {
              if (window[X_HIDE]) {
                productName = 'SCRM专业'
              } else {
                productName = (process.env.NODE_ENV == 'erp-prod' || process.env.NODE_ENV == 'erp') ? 'ERP-臻寻客' : 'T云-臻寻客'
              }
            }
          }
          let paramsM = {
            eventType: 'advanced_search',//事件类型
            productName: productName,//产品线名称
            advancedSearchDTO: { data: { ...params } },
            count: this.allTotal
          }
          if (this.searchFlag) {
            testPoint(paramsM).then(res => {
              this.searchFlag = false
            }).catch(err => {

            })
          }

          this.$refs.cardlist.contactCount()
        }
      } catch (error) {
        this.loading = false
      }
    },
    updateTemplate() {
      this.filterKey++
    },
    async saveOrUpdateTemplate(templateName) {
      const { code, message } = await saveOrUpdateTemplate({ templateName, options: JSON.stringify(this.$store.getters.getDefaultCondition) })
      if (code === 200) {
        this.$message.success('保存成功')
        this.$refs.advanceSearchTab.getTabData(true)
      } else {
        this.$message.success(message)
      }
    },
    // 批量解锁前500
    batchUnlockFnbefore() {
      // 重新获取解锁数据
      this.$store.commit('SET_FREQUENCY', this.$store.state.user.frequency + 1)
      this.unlockDialogShowBatch = true
    },
    async contactsNumBatchConfirmBatch() {
      try {
        let isUnlockN = this.isUnlock ? 1 : 0
        const { data, code } = await advancedSearchUnlock({
          pageNum: this.list.pageNum,
          pageSize: this.list.pageSize,
          isUnLock: parseInt(isUnlockN),
          data: this.searchConditionObj
        })

        if (code === 200) {
          if (this.staffInfo.demonstrationTag != 1) {
            this.$message.warning('批量解锁中，所需时长5分钟，请稍后在解锁列表中查看')
          }
          this.search()
          this.$refs.batchUnlockTip.getUnlockBatchTip()
          this.$refs.batchUnlockTip.tipTitleF('2')
        }
      } catch (error) {
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.advancedSearch_main {
  padding: 0 !important;
  // margin: 0 !important;
  // min-width: 1100px;
  // width: calc(100% - 48px) !important;
  // background: #fff;
  padding: 20px;
  /deep/ .el-loading-mask {
    top: 24px;
  }
  /deep/ .el-loading-mask > .el-loading-spinner {
    // top: 115px;
    top: 178px;
  }
}
.search-content {
  background: #fff;
  height: 525px;
  /deep/ .el-col {
    height: 100%;
  }
}
.btns {
  padding: 20px;
  border-top: 1px solid #f2f2f2;
  // border-bottom: 50px solid #f0f2f5;
}
.left-shadow {
  // width: 320px;
  width: 286px;
  box-sizing: border-box;
}

.cardlist {
  // width: 100%;
  // max-width: 1200px;
  // margin: 0 auto;
  /deep/ .cardTitle {
    // width: 100%;
    padding: 0 120px;
  }
  /deep/ .clueList {
    // padding-top: 10px;
    // width: calc(100% - 240px);
    margin: 0 auto;
  }
}
.btns.btnsMd {
  text-align: center;
  padding: 15px 20px;
  box-sizing: border-box;
  background: #fff;
  .el-button.is-w100 {
    box-shadow: 0px 2px 4px 0px #edeef3;
  }
  .el-button + .el-button {
    margin-left: 30px;
  }
  .el-button {
    &.el-button--dialog-confirm {
      box-shadow: 0px 6px 10px 0px rgba(80, 136, 255, 0.2);
    }
  }
}
.font-16-md {
  font-size: 16px;
  font-weight: 600;
  color: rgba(52, 57, 81, 0.7);
}
.font-15-md {
  font-size: 15px;
  font-weight: 600;
  color: rgba(52, 57, 81, 0.7);
}

::v-deep {
  .btnBlock {
    .filter-unlock {
      color: rgb(80, 136, 255);
      margin-right: 0;
      line-height: 38px;
      .el-radio__input.is-checked + .el-radio__label {
        color: rgb(80, 136, 255);
      }
      .el-radio__input.is-checked .el-radio__inner {
        border-color: rgb(80, 136, 255);
        background: rgb(80, 136, 255);
      }
      .el-radio__inner,
      .el-checkbox__inner {
        border: 1px solid rgb(80, 136, 255);
        width: 14px;
        height: 14px;
      }
      .el-checkbox__inner::after {
        top: 1px;
        left: 4px;
      }
    }
  }
  .el-loading-spinner {
    .el-loading-text {
      font-weight: 400;
      color: #999999;
      font-size: 13px;
      margin-top: 14px;
    }
    .el-icon-loading:before {
      content: url("~@/assets/gbIcon/loading_icon.png");
    }
  }

  .el-loading-spinner i {
    font-size: 24px;
  }
  .el-input__inner {
    box-shadow: none;
  }
}
.gbBatchBtn {
  &.el-button {
    color: #333333;
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0px 2px 4px 0px #edeef3;
    border-radius: 4px;
    border: 1px solid #bbbeca;
    margin-left: 8px;
  }
}
</style>
<style lang="scss">
.winClass {
  width: 350px;
  min-width: auto;
  border-radius: 4px;
  padding-bottom: 0 !important;
  border: none;
  .el-input__inner {
    box-shadow: none;
    height: 32px;
    line-height: 32px;
  }
  .el-button {
    width: 88px;
    padding-top: 0;
    padding-bottom: 0;
    line-height: 32px;
    height: 32px;
  }
  .el-message-box__btns button:nth-child(2) {
    margin-left: 30px;
  }
  .el-message-box__header {
    background: #fbfbfb;
    padding: 0 18px 0 24px;
    box-sizing: border-box;
    .el-message-box__title {
      height: 42px;
      line-height: 42px;
      font-weight: 600;
      color: #666666;
      font-size: 14px;
    }
    .el-message-box__headerbtn {
      top: 10px;
      .el-message-box__close,
      .el-icon-close:before {
        width: 20px;
        height: 20px;
        font-size: 20px;
      }
    }
  }
  .el-message-box__content {
    padding: 24px 24px 0;
    box-sizing: border-box;
    .el-message-box__message {
      p {
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        font-size: 14px;
      }
    }
    .el-message-box__input {
      padding-top: 8px;
      padding-bottom: 14px;
    }
  }
  .el-message-box__btns {
    text-align: center;
    height: 56px;
    line-height: 56px;
    background: #fafafa;
    padding: 0;
    .el-icon-close:before {
      font-size: 14px;
    }
  }
  .el-message-box__errormsg {
    margin-top: 4px;
  }
  &.delClass {
    .el-message-box__content {
      padding-bottom: 24px;
    }
    .el-message-box__status {
      position: relative;
      display: block;
      margin: auto;
      text-align: center;
      top: 16px;
      background: url(~@/assets/gbIcon/warning_icon.png) no-repeat center;
      width: 50px;
      height: 50px;
      &::before {
        display: none;
      }
    }
    .el-message-box__status + .el-message-box__message {
      padding: 0;
      text-align: center;
    }
  }
}
.goUPDown {
  position: fixed;
  right: 0px;
  bottom: 70px;
  img {
    cursor: pointer;
    display: block;
    margin: auto;
  }
}
</style>
